import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    SAVE_CLIENTNAME,
    SELECT_AZMANA,
    SELECT_CURRENT_ORDER,
} from '../../../../../../store/actions/actionsTypes';
import { LINKS } from '../../../../../Routs/config';
import { convertToDate } from '../../../../../modules/convertDateString';
import { statusConverter } from '../../../../../generic/artcoded/statusAzmanot';
import LikutOrderRow from './LikutOrderRow';
import { IOrderGoItem, TCheckForActiveLikutAzmana } from '../types/list';

interface Props {
    order: IOrderGoItem;
    setAzmanaNum: (orderID: number) => void;
    checkForActiveLikutAzmana: TCheckForActiveLikutAzmana;
    clientList: { hashTable: Record<number, { RampId?: number }> } | null;
    isAddIdToDesc: boolean;
    groupColor?: string;
    isLast?: boolean;
}

const LikutAzmanaRowItem: React.FC<Props> = ({
    order,
    setAzmanaNum,
    checkForActiveLikutAzmana,
    clientList,
    isAddIdToDesc,
    groupColor,
    isLast = false,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        OrderID,
        CustomerID,
        Customer_Name,
        Delivery_Date,
        Status,
        GroupID,
        GroupDesc,
        WorkerID,
        TZSort,
        Products,
        Pallets15,
        Weight,
        GivenWeight,
        Packages,
        GivenPackages,
        Pieces,
        GivenPieces,
    } = order;

    const statusInfo = useMemo(() => {
        const { status, color } = statusConverter(Status);
        return status ? { label: status, bg: color } : undefined;
    }, [Status]);

    const passFunc = () => {
        setAzmanaNum(OrderID);
        dispatch({ type: SELECT_CURRENT_ORDER, payload: order });
        dispatch({ type: SELECT_AZMANA, payload: OrderID, group: GroupID, status: Status, client: CustomerID });
        dispatch({ type: SAVE_CLIENTNAME, payload: Customer_Name });
        navigate(LINKS.likut.likutExperess.palletSection);
    };

    return (
        <LikutOrderRow
            orderId={OrderID}
            dateLabel={convertToDate(Delivery_Date)}
            clientName={Customer_Name?.trim()}
            customerId={isAddIdToDesc ? CustomerID : undefined}
            groupDesc={GroupDesc?.trim() || undefined}
            groupColor={groupColor}
            rampId={clientList?.hashTable[CustomerID]?.RampId}
            products={Products}
            pallets={Pallets15}
            weightLabel={`${Weight} / ${GivenWeight}`}
            packagesLabel={`${Packages} / ${GivenPackages}`}
            piecesLabel={`${Pieces} / ${GivenPieces}`}
            status={statusInfo}
            isLast={isLast}
            onClick={() =>
                checkForActiveLikutAzmana(Status, CustomerID, 1, OrderID, passFunc, WorkerID, TZSort)
            }
        />
    );
};

export default LikutAzmanaRowItem;
